/**
 * 检查用户不接受额度状态接口Req
 */
export interface ICheckUserLoanStatusReq {
    /**
     * 产品编号
     */
    prodNo: string
}

/**
 * h5查询用户地址
 */
export interface IGetUserAdrReq {
    key: string
    iv: string
}

export interface IGetUserInfoReq {
    key?: string
    iv?: string
}


/**
 * 检查用户不接受额度状态接口Resp
 */
export interface ICheckUserLoanStatusResp {
    /**
     * 检查结果：1表示不允许申请，0表示允许申请
     */
    checkRes: number
    /**
     * 检查结果描述
     */
    checkDesc: string
    /**
     * 用户拒绝的时间，时间戳
     */
    userRejectTime: string | undefined
    /**
     * 允许用户再次申请的时间，时间戳
     */
    allowApplyTime: string | undefined

    allowApplyTimeStr: string
}

export enum RESIDENCETYPE {
    /**
     * 证件信息异常
     */
    UNKNOW = -1,
    /**
     * 永居类型
     */
    RESIDENTPERMANENT = 1,
    /**
     * 非永居类型
     */
    RESIDENTNOPERMANENT = 2
}

export interface IGetUserInfpResp {
    enName: string
    name: string
    gsmCode: string
    mobile: string
    /**
     * 地址
     */
    residenceAddress: string
    addrArr: string[]
    // resdenceType: RESIDENCETYPE
}

export interface IUserStatusInfo {
    status: number
    acctNo: string | null | undefined
    freezeStatus: string | null | undefined
    gid: any
    custNo: string
    uid: any
}

export interface IGetLimitListReq {
    acctNo: string | null | undefined
    gid: any
    custNo: string
    uid: any
    productNo?: string
    status?: string
    seq?: string
}

export interface IGetWhiteListItemReq {
    keyword: string
}

export interface IGetWhiteListItemResp {
    flag: boolean
}
